/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable no-case-declarations */
import { getActionType } from '../util/redux';
import { TalentType } from '../action/talent';

const initState = {
    request: false,
    data: {
        talentTypeList: []
    },
    info: {

    },
    ordinaryInfo: {

    },
    msg: ''
};
const type1 = getActionType(TalentType, 'request');
const type2 = getActionType(TalentType, 'success');
const type3 = getActionType(TalentType, 'fail');
const type4 = getActionType(TalentType, 'typesuccess');
const type5 = getActionType(TalentType, 'typefail');
const type7 = getActionType(TalentType, 'usesuccess');
const type9 = getActionType(TalentType, 'addsuccess');
const type10 = getActionType(TalentType, 'addfail');
const type11 = getActionType(TalentType, 'ordinarysuccess');

export default function talentReducer(state = initState, action) {
    const { type, payload } = action;
    switch (type) {
        case type1:
            return {
                ...state,
                request: true,
                msg: ''
            };
        case type2:
            return {
                ...state,
                request: false,
                info: payload.data,
            };
        case type3:
            const rmsg = payload.msg;
            return {
                ...state,
                request: false,
                msg: rmsg
            };
        case type4:
            const talentTypeList = [];
            payload.data.forEach((e) => {
                e.label = e.value = e.name;
                talentTypeList.push(e);
            });
            return {
                ...state,
                data: { talentTypeList }
            };
        case type5:
            return state;
        case type7:
            const promotionResourceVos = JSON.parse(JSON.stringify(state.info.promotionResourceVos));
            promotionResourceVos.map((item) => {
                if (item.type === payload.type) {
                    item.remain -= payload.amount;
                    item.used += payload.amount;
                }
            });
            return {
                ...state,
                info: {
                    ...state.info,
                    promotionResourceVos
                }
            };
        case type9:
            return {
                ...state,
                info: {
                    ...state.info,
                    // state: 0
                }
            };
        case type10:
            return state;
        case type11:
            return {
                ...state,
                ordinaryInfo: payload.data
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./client/reducers/talent.js